import api from './utilPartner';

const controller = 'AgendaPagamento';
const url = process.env.VUE_APP_ROOT_API + controller;
export default Object.assign({}, api.GetCrud(controller, null), {
  Listar: function (dto) {
    return api.Axios.GetParams(url + '/Listar', dto);
  },
  ListarParcelas: function (dto) {
    return api.Axios.GetParams(url + '/ListarParcelas', dto);
  },
  Detalhes: function (dto) {
    return api.Axios.GetParams(url + '/LocalizarRegistro', dto);
  },
  DetalhesParcela: function (dto) {
    return api.Axios.GetParams(url + '/LocalizarRegistroParcela', dto);
  }
});
